export const JOB_DETAIL_SET = 'JOB_DETAIL_SET'
export const JOB_DETAIL_LOAD = 'JOB_DETAIL_LOAD'
export const JOB_DETAIL_SUCCESS = 'JOB_DETAIL_SUCCESS'
export const JOB_DETAIL_FAILED = 'JOB_DETAIL_FAILED'
export const JOB_DETAIL_CLEAR = 'JOB_DETAIL_CLEAR'
